/*@flow*/
import animateText from 'lib/animateText';
import { useEffect } from 'react';

export default (ref: {| current: null | HTMLElement |}, value: number) => {
  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    animateText(el, value);
  }, [ref, value]);
};
